import { formatDateLong } from "@/lib/format-date";
import { Link } from "@tanstack/react-router";

interface ReviewStampProps {
  lastReviewed: string;
  author: { name: string; credentials: string; slug?: string };
  className?: string;
}

/**
 * Authority / E-E-A-T signal: shows the reviewer + last-reviewed date on every
 * leaf content page. Rendered as <time> for crawler clarity.
 */
export function ReviewStamp({ lastReviewed, author, className }: ReviewStampProps) {
  const formatted = formatDateLong(lastReviewed);
  const nameNode = author.slug ? (
    <Link
      to="/about-employerhq"
      hash={`author-${author.slug}`}
      className="font-medium text-foreground underline decoration-accent/50 underline-offset-2 hover:text-accent"
    >
      {author.name}
    </Link>
  ) : (
    <span className="font-medium text-foreground">{author.name}</span>
  );
  return (
    <div
      className={
        className ??
        "mx-auto mt-6 flex max-w-7xl flex-wrap items-center gap-x-4 gap-y-1 px-6 text-xs text-muted-foreground lg:px-8"
      }
    >
      <span>
        Reviewed by {nameNode}
        <span className="text-muted-foreground"> · {author.credentials}</span>
      </span>
      <span aria-hidden="true">·</span>
      <span>
        Last reviewed{" "}
        <time dateTime={lastReviewed}>{formatted}</time>
      </span>
    </div>
  );
}
